import React, { useState, useRef, useEffect } from "react";
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import "./cart.css";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../components/CheckoutForm";
import tote1 from "../images/tote-1.png";
import tote2 from "../images/tote-6.png";
import straw from "../images/straw.jpeg";

import CartProduct from "../components/Cart";

const promise = loadStripe("pk_live_51IPGT7BdCFqUItDG57omJAYI80sR2P7w9DBrGyn5K48X51zSIJbGE9caKZOBxIJ5gwhBrtpI3cF2FkED7tbXclDm00WWk4Cvh7");

const Cart = () => {
  const [total, setTotal] = useState(1);
  const [products, setProducts] = useState({});




  const GetProducts = async () => {
    if (localStorage.getItem("id") === null) {
        localStorage.setItem("id", uuidv4())
    }
    
    
    await axios.get('https://ggi-store.herokuapp.com/cart', {
        params: {
            user: localStorage.getItem("id")
        }
    }).then(res => {
      setProducts(res.data);

      var ttotal = 0;


      Object.entries(res.data).map(([index, value]) => {
        ttotal += value.quantity * value.price;
      });

      // alert("Total" + ttotal);
      setTotal(ttotal);
      localStorage.setItem("total", ttotal);
      // if (localStorage.getItem("total") === null) {
      //   localStorage.setItem("total", ttotal);
      // }

      // alert("HERE");
    })
    .catch(err => {
        alert("Something is wrong on our side. Please try again later")
        console.log('Error: ' + err)
    });
  }

  const productList = Object.entries(products).map(([index, value]) => {
      return (
        <CartProduct k={index} name={value.name} quantity={value.quantity} price={Number(value.quantity) * Number(value.price)} v={value.price} total={total} updateTotal={( a ) => setTotal(a)} />
      )
  });
    
  useEffect(() => {
    GetProducts();
  }, []);

  return (
    <div className="content">
      <section className="main">
        <h1 className="buy">Checkout</h1>
        {/* <h1 className="cartEmpty">Cart Empty</h1> */}
        {Object.keys(products).length == 0 ? ("") : 
        
        (
        <div className="page-content">
          <table className="content-table">
            <thead>
                <tr>
                  <th>Product</th>
                  <th>Name</th>
                  <th>Quantity</th>
                  <th>Price</th>
                </tr>
            </thead>
            <tbody>
              { productList }
              <tr className="total-price">
                <td></td>
                <td></td>
                <td>Total:</td>
                <td>${ total }</td>
              </tr>
            </tbody>
          </table>

          <div class="container login-content">
              <Elements options={{
                fonts: [
                  {
                    cssSrc:
                      "https://fonts.googleapis.com/css2?family=Sora&display=swap"
                  }
                ]}}
          
            stripe={promise}>
                {Object.keys(products).length == 0 ? ("") : (<CheckoutForm products={products} total={total} />)}
              </Elements>
            </div>
        </div>
        )}
      </section>
    </div>
  );
};

export default Cart;
